module.exports = __webpack_public_path__ + "static/the-war-for-kindness-bf456d433ea24dac2deb99db9e2ba440.jpg";